import { ICoursesByWeek } from '../../../graphql/types/queries/course';
import { ISummary } from '../LastCourses';

export const weeksSummary = (byWeeks: ICoursesByWeek[]): ISummary[] => {
  const summary = [];
  let weekGroup: {
    weekNumber: number;
    journeyName: string;
    courses: ICoursesByWeek[];
  }[] = [];
  for (let index = 0; index < byWeeks.length; index++) {
    const element = byWeeks[index];
    let foundWeek = weekGroup.findIndex(x => x.weekNumber === element.week);
    if (foundWeek < 0) {
      weekGroup.push({
        weekNumber: element.week,
        journeyName: element.journeyName,
        courses: [element]
      });
    } else {
      weekGroup[foundWeek].courses.push(element);
    }
  }

  for (let index = 0; index < weekGroup.length; index++) {
    const element = weekGroup[index];
    let complete = true;
    let notStarted = true;
    let pct = 0;
    let courseCount = 0;
    for (let i = 0; i < element.courses.length; i++) {
      const courses = element.courses[i];
      for (let ii = 0; ii < courses.courses.length; ii++) {
        const course = courses.courses[ii];
        if (!course.isComplete) complete = false;
        if (!!course.isStarted) notStarted = false;
        pct += course.progress;
        courseCount++;
      }
    }

    summary.push({
      weekNumber: element.weekNumber,
      journeyName: element.journeyName,
      complete,
      notStarted,
      pct: (pct / courseCount)
    });
  }
  return summary;
};
